export const participation_forms = [
    {
        title:"Usmeno izlaganje",
	text:
	[
	    {
		title:"",
            text:"Usmeno izlaganje traje 10 minuta, nakon čega slijedi 5-minutna rasprava. U okviru usmenih \
izlaganja prihvaćaju se dvije kategorije radova, a prijavitelji pri prijavi odabiru jednu od \
ponuđenih kategorija:\n\n\ ",
	    },
	    {
		title:"Psihologija u fokusu",
		text:"Izlaganje pojedinačnog znanstvenog istraživanja u trajanju od 10 minuta, uz 5 minuta rasprave \
Ova forma namijenjena je predstavljanju empirijskih radova koji donose nove spoznaje, \
teorijske doprinose ili relevantne uvide za praksu u različitim područjima psihologije. \
Sažetak empirijskog rada treba sadržavati jasno definiran cilj i/ili istraživačke probleme, opis \
metodologije (sudionici, instrumenti, postupak), prikaz glavnih rezultata te njihovu \
interpretaciju i ključne zaključke. Poželjno je istaknuti teorijski i/ili praktični doprinos rada te \
naznačiti moguće implikacije za daljnja istraživanja ili primjenu u praksi.\n\n \
Omjer pojedinih dijelova sažetka treba biti uravnotežen, a stil pisanja jasan i precizan. U sažetku \
se ne navode referentni izvori, a rezultate statističkih analiza preporučuje se navesti opisno. \
Tekst sažetka treba biti dugačak 200–300 riječi te treba sadržavati 3–5 ključnih riječi.",
	    },
	    {
		title:"Psihologija u akciji",
		text:"Izlaganje u trajanju od 10 minuta, uz 5 minuta rasprave, namijenjeno je predstavljanju primjene \
psihologije u praksi. Ova forma obuhvaća stručna predavanja, prikaze projekata te prikaze \
stručne prakse, odnosno predstavljanje konkretnih profesionalnih postupaka, intervencija, \
programa ili projekata s jasnim i primjenjivim ishodima.\n\n\
Sažetak treba sadržavati opis profesionalnog ili projektnog konteksta, jasno definiran cilj rada ili \
projekta, prikaz provedenih aktivnosti, intervencija ili postupaka te opis postignutih ishoda. \
Poželjno je istaknuti izazove provedbe, naučene lekcije i preporuke za primjenu u drugim \
profesionalnim okruženjima.\n\n\
Naglasak je na primjenjivosti, praktičnim rješenjima i iskustvima iz prakse u različitim \
područjima psihologije (npr. kliničkom, obrazovnom, organizacijskom i drugim stručnim \
kontekstima). Tekst sažetka treba biti dugačak 200–300 riječi te treba sadržavati 3–5 ključnih \
riječi.",
	    }]
    },


    {
        title:"Simpozij",
	text:[
	    {
		title:"",
		text:"Osim voditelja, koji organizira i prijavljuje simpozij, za prijavu simpozija potrebno je najmanje 4, \
a najviše 6 usmenih izlaganja različitih autora koji se bave zajedničkom temom ili nizom \
tematski povezanih istraživanja. Trajanje izlaganja u okviru simpozija jednako je kao i kod drugih \
usmenih izlaganja (15 minuta: 10 minuta izlaganje, nakon kojeg slijedi 5-minutna rasprava). \
Ukupno trajanje simpozija može biti od 60 do 90 minuta.\n\n \
Sažetak simpozija, kao i sažetke svih izlaganja u sklopu simpozija, prijavljuje voditelj simpozija. \
Voditelj u prijavi treba navesti (a) naslov simpozija, (b) ime i prezime, instituciju, grad, državu i \
e-mail voditelja, (c) sažetak simpozija koji sadrži opis i obrazloženje teme simpozija, uključujući \
pregled tema pojedinih izlaganja, u opsegu 200–400 riječi, (d) 3–5 ključnih riječi, (e) popis \
naslova svih izlaganja u okviru simpozija (s imenom i prezimenom autora) onim slijedom kojim \
bi trebali biti izlagani na simpoziju.\n\n \
Voditelj simpozija odgovoran je za istovjetnost navoda u ovom sažetku s naslovima i imenima \
autora u sažecima pojedinih izlaganja u simpoziju, kao i za obavještavanje sudionika simpozija o \
odluci Programskog odbora o (ne)prihvaćanju simpozija. U slučaju nepravovremenih ili \
nepotpunih prijava voditeljskog i/ili individualnih sažetaka, Programski odbor neće razmatrati \
prijavu simpozija.\n\n \
Pojedina izlaganja bit će recenzirana zasebno i, u slučaju negativne recenzije zbog koje se \
ukupni broj izlaganja u simpoziju smanjuje ispod ranije definiranog minimuma, simpozij u okviru \
kojeg je konkretno izlaganje planirano neće biti prihvaćen. Autorima pozitivno recenziranih \
pojedinih izlaganja bit će ponuđena mogućnost sudjelovanja na skupu izvan planiranog \
simpozija."
	    },
	    {
		title: "Koraci u prijavi sažetka simpozija i sažetaka radova unutar simpozija",
		text: "Voditelj simpozija najprije ispunjava prijavu sažetka simpozija:",
		ul:["odabrati vrstu izlaganja – simpozij,",
		    "upisati svoje ime i e-mail adresu za kontakt,",
		    "pod naslov rada upisati naziv simpozija,",
		    "pod autore upisati svoje ime i instituciju,",
		    "unijeti sažetak cijelog simpozija (u sažetku se navode i imena autora koji će u okviru simpozija izlagati svoje radove)."]
	    },
	    {
		title: "Prijava pojedinačnih radova unutar simpozija",
		text: "Nakon prijave simpozija, voditelj simpozija pojedinačno prijavljuje svaki rad koji je sastavni dio simpozija, ispunjavajući zasebni obrazac za svaki rad, i to na sljedeći način:",
		ul: ["odabrati oblik sudjelovanja – usmeno izlaganje unutar simpozija,",
		     "upisati svoje ime i e-mail adresu za kontakt,",
		     "pod naslov rada upisati naslov pojedinog rada u simpoziju i naziv simpozija čiji je rad dio,",
		     "pod autore upisati autora/e pojedinog rada i njihove institucije,",
		     "unijeti sažetak  pojedinog rada"
		    ]
	    },
	    {
		title: "Ponavljanje postupka",
		text: "Način unosa naveden u točki 2 voditelj simpozija treba ponoviti za svaki pojedini rad u simpoziju."
	    }
	]

    },

    {
        title:"Okrugli stol",
        text:"Okrugli stol namijenjen je stručnoj raspravi u kojoj sudionici ravnopravno sudjeluju u razmjeni \
argumenata i iskustava, bez zasebnih uvodnih izlaganja ili uz njihovo minimalno trajanje. \
Naglasak je na dijalogu među sudionicima i zajedničkom produbljivanju teme, a ne na \
predstavljanju pojedinačnih perspektiva.\n\n\
Okrugli stol organizira i prijavljuje voditelj. Sažetak treba sadržavati jasno obrazloženje teme \
rasprave, njezine relevantnosti za psihološku struku te opis ključnih pitanja o kojima će se \
raspravljati. U prijavi je potrebno navesti sudionike okruglog stola i planirano trajanje (60 ili 90 \
minuta). Tekst sažetka treba biti dugačak 200–300 riječi te treba navesti 3–5 ključnih riječi."

    },
    {
	title:"Panel rasprava",
	text:"Panel rasprava namijenjena je predstavljanju i usporedbi različitih perspektiva, profesionalnih \
uloga ili iskustava vezanih uz istu temu, pri čemu svaki sudionik iznosi svoj pogled, a razgovor \
vodi moderator. Za razliku od okruglog stola, u panel raspravi sudionici nemaju ravnopravnu \
raspravnu ulogu, već sudjeluju kroz moderirani razgovor koji je strukturiran pitanjima \
moderatora i, prema potrebi, kratkim uvodnim izlaganjima.\n\n\
Panel raspravu organizira i prijavljuje voditelj. Sažetak treba sadržavati obrazloženje teme, opis \
perspektiva ili uloga pojedinih sudionika te planirani način moderiranja rasprave. U prijavi je \
potrebno navesti sudionike panela i planirano trajanje (60 ili 90 minuta). Tekst sažetka treba biti \
dugačak 200–300 riječi te treba navesti 3–5 ključnih riječi."
    },
    {
        title:"Radionica",
        text:"Aktivnost koju organizira i vodi prijavljeni voditelj u trajanju od 60 ili 90 minuta. Sažetak treba \
sadržavati kratki prikaz cilja, očekivanih ishoda za polaznike radionice, planiranih aktivnosti, \
predloženo trajanje radionice (60 ili 90 minuta) te napomenu o eventualnom ograničenju broja \
sudionika i drugim mogućim posebnim zahtjevima. Tekst sažetka treba biti dugačak 200-300 \
riječi te treba navesti 3-5 ključnih riječi."

    },
        {
        title:"Poster izlaganje",
            text:"Prezentacije različitih tema, koje omogućuju intenzivniju interakciju autora s drugim \
sudionicima tijekom trajanja vođene poster-sekcije. Dimenzije postera ne smiju prelaziti B1 \
(707x1000 mm). Ako poster prikazuje rezultate empirijskog istraživanja, struktura i sadržaj \
sažetka trebaju biti kao i kod usmenog izlaganja (v. „Usmeno izlaganje“). Tekst sažetka treba biti \
dugačak 200-300 riječi te treba navesti 3-5 ključnih riječi."
    },

    {
        title:"Stručni domjenak",
        text:"Druženje sudionika koji dijele zajedničke interese. Sažetak treba sadržavati cilj i obrazloženje \
planiranog druženja, predviđeni broj sudionika i trajanje, uz eventualne napomene glede \
posebnih dodatnih zahtjeva ili ograničenja. Tekst sažetka treba biti dugačak 200-300 riječi te \
treba navesti 3-5 ključnih riječi."

    },

    {
        title:"Sastanak stručne sekcije/radne skupine",
        text:"Za vrijeme skupa može se organizirati sastanak neke od stručnih sekcija HPD-a ili sastanak \
pojedinih radnih skupina itd. Sažetak treba sadržavati cilj i obrazloženje planiranog sastanka, \
predviđeni broj sudionika i trajanje sastanka (30 ili 60 minuta), uz eventualne napomene glede \
posebnih dodatnih zahtjeva ili ograničenja. Tekst sažetka treba biti dugačak 200-300 riječi te \
treba navesti 3-5 ključnih riječi."

    },

]

export const participation_additional = [

    {
        title:"Predstavljanje knjiga, psihologijskih mjernih instrumenata te drugih publikacija i uradaka",
        text:"Na skupu se može organizirati predstavljanje knjiga, psihologijskih mjernih instrumenata te \
drugih publikacija i uradaka. U prijavi aktivnosti treba navesti osnovne podatke o organizatoru i \
promotoru, popis drugih aktivnih sudionika sa svim osnovnim podacima kao i za organizatora te \
trajanje predstavljanja (15, 30 ili 60 minuta), a u sažetku navesti detaljne podatke o publikaciji ili \
mjernom instrumentu koji se predstavlja te eventualne dodatne napomene Programskom \
odboru. Tekst sažetka treba biti dugačak 200-300 riječi te treba navesti 3-5 ključnih riječi."

    },
    {
        title:" Ostale aktivnosti",
        text:"Na GKHP moguće je prijaviti i druge oblike sudjelovanja, koji nisu već navedeni u online obrascu \
prijave. Kao i kod drugih oblika sudjelovanja, prijava se mora napraviti putem online obrasca do \
roka za prijavu sažetaka. Sažetak treba sadržavati naslov i jasan opis planirane aktivnosti, kao i \
podatke o drugim sudionicima te eventualne dodatne napomene Programskom odboru. Tekst \
sažetka treba biti dugačak 200-300 riječi te treba navesti 3-5 ključnih riječi."

    },
]
